import { c as pe } from "./createLucideIcon-DSKUQ9gX.mjs.js";
import { g as Ne, b as Le, r as c, j as O, R as A, d as ye } from "./client-BkmPNNjT.mjs.js";
import { u as I, c as te } from "./utils-DrJAg__I.mjs.js";
const Me = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Jt = pe("check", Me);
const De = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], en = pe("chevron-down", De), tn = async (e, t) => {
  if (!window.__STOREFRONT_ACCESS_TOKEN__)
    throw new Error("Storefront access token is not set");
  const n = await fetch(`${window.Shopify.routes.root === "/" ? "" : window.Shopify.routes.root}/api/2025-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": window.__STOREFRONT_ACCESS_TOKEN__
    },
    body: JSON.stringify({
      query: e,
      variables: t
    })
  });
  if (!n.ok)
    throw new Error(`Response status: ${n.status}`);
  return await n.json();
};
var Ee = Le();
const ke = /* @__PURE__ */ Ne(Ee);
function nn(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function X(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e?.(o), n === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function rn(e, t) {
  const n = c.createContext(t), r = (s) => {
    const { children: u, ...a } = s, h = c.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ O.jsx(n.Provider, { value: h, children: u });
  };
  r.displayName = e + "Provider";
  function o(s) {
    const u = c.useContext(n);
    if (u) return u;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Ie(e, t = []) {
  let n = [];
  function r(s, u) {
    const a = c.createContext(u), h = n.length;
    n = [...n, u];
    const l = (v) => {
      const { scope: m, children: E, ...w } = v, i = m?.[e]?.[h] || a, f = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ O.jsx(i.Provider, { value: f, children: E });
    };
    l.displayName = s + "Provider";
    function d(v, m) {
      const E = m?.[e]?.[h] || a, w = c.useContext(E);
      if (w) return w;
      if (u !== void 0) return u;
      throw new Error(`\`${v}\` must be used within \`${s}\``);
    }
    return [l, d];
  }
  const o = () => {
    const s = n.map((u) => c.createContext(u));
    return function(a) {
      const h = a?.[e] || s;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: h } }),
        [a, h]
      );
    };
  };
  return o.scopeName = e, [r, Fe(o, ...t)];
}
function Fe(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const u = r.reduce((a, { useScope: h, scopeName: l }) => {
        const v = h(s)[`__scope${l}`];
        return { ...a, ...v };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function on(e) {
  const t = e + "CollectionProvider", [n, r] = Ie(t), [o, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (i) => {
    const { scope: f, children: p } = i, y = A.useRef(null), b = A.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ O.jsx(o, { scope: f, itemMap: b, collectionRef: y, children: p });
  };
  u.displayName = t;
  const a = e + "CollectionSlot", h = te(a), l = A.forwardRef(
    (i, f) => {
      const { scope: p, children: y } = i, b = s(a, p), g = I(f, b.collectionRef);
      return /* @__PURE__ */ O.jsx(h, { ref: g, children: y });
    }
  );
  l.displayName = a;
  const d = e + "CollectionItemSlot", v = "data-radix-collection-item", m = te(d), E = A.forwardRef(
    (i, f) => {
      const { scope: p, children: y, ...b } = i, g = A.useRef(null), C = I(f, g), R = s(d, p);
      return A.useEffect(() => (R.itemMap.set(g, { ref: g, ...b }), () => void R.itemMap.delete(g))), /* @__PURE__ */ O.jsx(m, { [v]: "", ref: C, children: y });
    }
  );
  E.displayName = d;
  function w(i) {
    const f = s(e + "CollectionConsumer", i);
    return A.useCallback(() => {
      const y = f.collectionRef.current;
      if (!y) return [];
      const b = Array.from(y.querySelectorAll(`[${v}]`));
      return Array.from(f.itemMap.values()).sort(
        (R, S) => b.indexOf(R.ref.current) - b.indexOf(S.ref.current)
      );
    }, [f.collectionRef, f.itemMap]);
  }
  return [
    { Provider: u, Slot: l, ItemSlot: E },
    w,
    r
  ];
}
var _e = c.createContext(void 0);
function an(e) {
  const t = c.useContext(_e);
  return e || t || "ltr";
}
var Be = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], z = Be.reduce((e, t) => {
  const n = te(`Primitive.${t}`), r = c.forwardRef((o, s) => {
    const { asChild: u, ...a } = o, h = u ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ O.jsx(h, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function We(e, t) {
  e && Ee.flushSync(() => e.dispatchEvent(t));
}
function F(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => t.current?.(...n), []);
}
function je(e, t = globalThis?.document) {
  const n = F(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Ue = "DismissableLayer", ne = "dismissableLayer.update", $e = "dismissableLayer.pointerDownOutside", ze = "dismissableLayer.focusOutside", oe, be = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), He = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: a,
      ...h
    } = e, l = c.useContext(be), [d, v] = c.useState(null), m = d?.ownerDocument ?? globalThis?.document, [, E] = c.useState({}), w = I(t, (S) => v(S)), i = Array.from(l.layers), [f] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), p = i.indexOf(f), y = d ? i.indexOf(d) : -1, b = l.layersWithOutsidePointerEventsDisabled.size > 0, g = y >= p, C = Xe((S) => {
      const x = S.target, k = [...l.branches].some((V) => V.contains(x));
      !g || k || (o?.(S), u?.(S), S.defaultPrevented || a?.());
    }, m), R = Ye((S) => {
      const x = S.target;
      [...l.branches].some((V) => V.contains(x)) || (s?.(S), u?.(S), S.defaultPrevented || a?.());
    }, m);
    return je((S) => {
      y === l.layers.size - 1 && (r?.(S), !S.defaultPrevented && a && (S.preventDefault(), a()));
    }, m), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (oe = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), ae(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = oe);
        };
    }, [d, m, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), ae());
    }, [d, l]), c.useEffect(() => {
      const S = () => E({});
      return document.addEventListener(ne, S), () => document.removeEventListener(ne, S);
    }, []), /* @__PURE__ */ O.jsx(
      z.div,
      {
        ...h,
        ref: w,
        style: {
          pointerEvents: b ? g ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: X(e.onFocusCapture, R.onFocusCapture),
        onBlurCapture: X(e.onBlurCapture, R.onBlurCapture),
        onPointerDownCapture: X(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
He.displayName = Ue;
var Ke = "DismissableLayerBranch", Ve = c.forwardRef((e, t) => {
  const n = c.useContext(be), r = c.useRef(null), o = I(t, r);
  return c.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ O.jsx(z.div, { ...e, ref: o });
});
Ve.displayName = Ke;
function Xe(e, t = globalThis?.document) {
  const n = F(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let h = function() {
          ge(
            $e,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = h, t.addEventListener("click", o.current, { once: !0 })) : h();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, u = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Ye(e, t = globalThis?.document) {
  const n = F(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (s) => {
      s.target && !r.current && ge(ze, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ae() {
  const e = new CustomEvent(ne);
  document.dispatchEvent(e);
}
function ge(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? We(o, s) : o.dispatchEvent(s);
}
var Y = 0;
function cn() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ce()), document.body.insertAdjacentElement("beforeend", e[1] ?? ce()), Y++, () => {
      Y === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Y--;
    };
  }, []);
}
function ce() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var q = "focusScope.autoFocusOnMount", G = "focusScope.autoFocusOnUnmount", se = { bubbles: !1, cancelable: !0 }, qe = "FocusScope", Ge = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s,
    ...u
  } = e, [a, h] = c.useState(null), l = F(o), d = F(s), v = c.useRef(null), m = I(t, (i) => h(i)), E = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let i = function(b) {
        if (E.paused || !a) return;
        const g = b.target;
        a.contains(g) ? v.current = g : T(v.current, { select: !0 });
      }, f = function(b) {
        if (E.paused || !a) return;
        const g = b.relatedTarget;
        g !== null && (a.contains(g) || T(v.current, { select: !0 }));
      }, p = function(b) {
        if (document.activeElement === document.body)
          for (const C of b)
            C.removedNodes.length > 0 && T(a);
      };
      document.addEventListener("focusin", i), document.addEventListener("focusout", f);
      const y = new MutationObserver(p);
      return a && y.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", i), document.removeEventListener("focusout", f), y.disconnect();
      };
    }
  }, [r, a, E.paused]), c.useEffect(() => {
    if (a) {
      ue.add(E);
      const i = document.activeElement;
      if (!a.contains(i)) {
        const p = new CustomEvent(q, se);
        a.addEventListener(q, l), a.dispatchEvent(p), p.defaultPrevented || (Ze(nt(Se(a)), { select: !0 }), document.activeElement === i && T(a));
      }
      return () => {
        a.removeEventListener(q, l), setTimeout(() => {
          const p = new CustomEvent(G, se);
          a.addEventListener(G, d), a.dispatchEvent(p), p.defaultPrevented || T(i ?? document.body, { select: !0 }), a.removeEventListener(G, d), ue.remove(E);
        }, 0);
      };
    }
  }, [a, l, d, E]);
  const w = c.useCallback(
    (i) => {
      if (!n && !r || E.paused) return;
      const f = i.key === "Tab" && !i.altKey && !i.ctrlKey && !i.metaKey, p = document.activeElement;
      if (f && p) {
        const y = i.currentTarget, [b, g] = Qe(y);
        b && g ? !i.shiftKey && p === g ? (i.preventDefault(), n && T(b, { select: !0 })) : i.shiftKey && p === b && (i.preventDefault(), n && T(g, { select: !0 })) : p === y && i.preventDefault();
      }
    },
    [n, r, E.paused]
  );
  return /* @__PURE__ */ O.jsx(z.div, { tabIndex: -1, ...u, ref: m, onKeyDown: w });
});
Ge.displayName = qe;
function Ze(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (T(r, { select: t }), document.activeElement !== n) return;
}
function Qe(e) {
  const t = Se(e), n = ie(t, e), r = ie(t.reverse(), e);
  return [n, r];
}
function Se(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ie(e, t) {
  for (const n of e)
    if (!Je(n, { upTo: t })) return n;
}
function Je(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function et(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function T(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && et(e) && t && e.select();
  }
}
var ue = tt();
function tt() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = le(e, t), e.unshift(t);
    },
    remove(t) {
      e = le(e, t), e[0]?.resume();
    }
  };
}
function le(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function nt(e) {
  return e.filter((t) => t.tagName !== "A");
}
var H = globalThis?.document ? c.useLayoutEffect : () => {
}, rt = ye[" useId ".trim().toString()] || (() => {
}), ot = 0;
function sn(e) {
  const [t, n] = c.useState(rt());
  return H(() => {
    n((r) => r ?? String(ot++));
  }, [e]), t ? `radix-${t}` : "";
}
function un(e) {
  const [t, n] = c.useState(void 0);
  return H(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let u, a;
        if ("borderBoxSize" in s) {
          const h = s.borderBoxSize, l = Array.isArray(h) ? h[0] : h;
          u = l.inlineSize, a = l.blockSize;
        } else
          u = e.offsetWidth, a = e.offsetHeight;
        n({ width: u, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var at = "Portal", ct = c.forwardRef((e, t) => {
  const { container: n, ...r } = e, [o, s] = c.useState(!1);
  H(() => s(!0), []);
  const u = n || o && globalThis?.document?.body;
  return u ? ke.createPortal(/* @__PURE__ */ O.jsx(z.div, { ...r, ref: t }), u) : null;
});
ct.displayName = at;
var st = ye[" useInsertionEffect ".trim().toString()] || H;
function ln({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, s, u] = it({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, h = a ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const v = d.current;
      v !== a && console.warn(
        `${r} is changing from ${v ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = a;
    }, [a, r]);
  }
  const l = c.useCallback(
    (d) => {
      if (a) {
        const v = ut(d) ? d(e) : d;
        v !== e && u.current?.(v);
      } else
        s(d);
    },
    [a, e, s, u]
  );
  return [h, l];
}
function it({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), s = c.useRef(t);
  return st(() => {
    s.current = t;
  }, [t]), c.useEffect(() => {
    o.current !== n && (s.current?.(n), o.current = n);
  }, [n, o]), [n, r, s];
}
function ut(e) {
  return typeof e == "function";
}
function fn(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var lt = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, N = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), B = {}, Z = 0, we = function(e) {
  return e && (e.host || we(e.parentNode));
}, ft = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = we(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, dt = function(e, t, n, r) {
  var o = ft(t, Array.isArray(e) ? e : [e]);
  B[n] || (B[n] = /* @__PURE__ */ new WeakMap());
  var s = B[n], u = [], a = /* @__PURE__ */ new Set(), h = new Set(o), l = function(v) {
    !v || a.has(v) || (a.add(v), l(v.parentNode));
  };
  o.forEach(l);
  var d = function(v) {
    !v || h.has(v) || Array.prototype.forEach.call(v.children, function(m) {
      if (a.has(m))
        d(m);
      else
        try {
          var E = m.getAttribute(r), w = E !== null && E !== "false", i = (N.get(m) || 0) + 1, f = (s.get(m) || 0) + 1;
          N.set(m, i), s.set(m, f), u.push(m), i === 1 && w && _.set(m, !0), f === 1 && m.setAttribute(n, "true"), w || m.setAttribute(r, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", m, p);
        }
    });
  };
  return d(t), a.clear(), Z++, function() {
    u.forEach(function(v) {
      var m = N.get(v) - 1, E = s.get(v) - 1;
      N.set(v, m), s.set(v, E), m || (_.has(v) || v.removeAttribute(r), _.delete(v)), E || v.removeAttribute(n);
    }), Z--, Z || (N = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap(), B = {});
  };
}, dn = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = lt(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), dt(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, P = function() {
  return P = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, P.apply(this, arguments);
};
function Ce(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function vt(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var U = "right-scroll-bar-position", $ = "width-before-scroll-bar", ht = "with-scroll-bars-hidden", mt = "--removed-body-scroll-bar-size";
function Q(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function pt(e, t) {
  var n = c.useState(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var yt = typeof window < "u" ? c.useLayoutEffect : c.useEffect, fe = /* @__PURE__ */ new WeakMap();
function Et(e, t) {
  var n = pt(null, function(r) {
    return e.forEach(function(o) {
      return Q(o, r);
    });
  });
  return yt(function() {
    var r = fe.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), u = n.current;
      o.forEach(function(a) {
        s.has(a) || Q(a, null);
      }), s.forEach(function(a) {
        o.has(a) || Q(a, u);
      });
    }
    fe.set(n, e);
  }, [e]), n;
}
function bt(e) {
  return e;
}
function gt(e, t) {
  t === void 0 && (t = bt);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var u = t(s, r);
      return n.push(u), function() {
        n = n.filter(function(a) {
          return a !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var u = n;
        n = [], u.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var u = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), u = n;
      }
      var h = function() {
        var d = u;
        u = [], d.forEach(s);
      }, l = function() {
        return Promise.resolve().then(h);
      };
      l(), n = {
        push: function(d) {
          u.push(d), l();
        },
        filter: function(d) {
          return u = u.filter(d), n;
        }
      };
    }
  };
  return o;
}
function St(e) {
  e === void 0 && (e = {});
  var t = gt(null);
  return t.options = P({ async: !0, ssr: !1 }, e), t;
}
var Re = function(e) {
  var t = e.sideCar, n = Ce(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, P({}, n));
};
Re.isSideCarExport = !0;
function wt(e, t) {
  return e.useMedium(t), Re;
}
var Pe = St(), J = function() {
}, K = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: J,
    onWheelCapture: J,
    onTouchMoveCapture: J
  }), o = r[0], s = r[1], u = e.forwardProps, a = e.children, h = e.className, l = e.removeScrollBar, d = e.enabled, v = e.shards, m = e.sideCar, E = e.noRelative, w = e.noIsolation, i = e.inert, f = e.allowPinchZoom, p = e.as, y = p === void 0 ? "div" : p, b = e.gapMode, g = Ce(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = m, R = Et([n, t]), S = P(P({}, g), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(C, { sideCar: Pe, removeScrollBar: l, shards: v, noRelative: E, noIsolation: w, inert: i, setCallbacks: s, allowPinchZoom: !!f, lockRef: n, gapMode: b }),
    u ? c.cloneElement(c.Children.only(a), P(P({}, S), { ref: R })) : c.createElement(y, P({}, S, { className: h, ref: R }), a)
  );
});
K.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
K.classNames = {
  fullWidth: $,
  zeroRight: U
};
var Ct = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Rt() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Ct();
  return t && e.setAttribute("nonce", t), e;
}
function Pt(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ot(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var xt = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Rt()) && (Pt(t, n), Ot(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Tt = function() {
  var e = xt();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Oe = function() {
  var e = Tt(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, At = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ee = function(e) {
  return parseInt(e || "", 10) || 0;
}, Nt = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ee(n), ee(r), ee(o)];
}, Lt = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return At;
  var t = Nt(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Mt = Oe(), D = "data-scroll-locked", Dt = function(e, t, n, r) {
  var o = e.left, s = e.top, u = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(ht, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(D, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(U, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat($, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(U, " .").concat(U, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat($, " .").concat($, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(D, `] {
    `).concat(mt, ": ").concat(a, `px;
  }
`);
}, de = function() {
  var e = parseInt(document.body.getAttribute(D) || "0", 10);
  return isFinite(e) ? e : 0;
}, kt = function() {
  c.useEffect(function() {
    return document.body.setAttribute(D, (de() + 1).toString()), function() {
      var e = de() - 1;
      e <= 0 ? document.body.removeAttribute(D) : document.body.setAttribute(D, e.toString());
    };
  }, []);
}, It = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  kt();
  var s = c.useMemo(function() {
    return Lt(o);
  }, [o]);
  return c.createElement(Mt, { styles: Dt(s, !t, o, n ? "" : "!important") });
}, re = !1;
if (typeof window < "u")
  try {
    var W = Object.defineProperty({}, "passive", {
      get: function() {
        return re = !0, !0;
      }
    });
    window.addEventListener("test", W, W), window.removeEventListener("test", W, W);
  } catch {
    re = !1;
  }
var L = re ? { passive: !1 } : !1, Ft = function(e) {
  return e.tagName === "TEXTAREA";
}, xe = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Ft(e) && n[t] === "visible")
  );
}, _t = function(e) {
  return xe(e, "overflowY");
}, Bt = function(e) {
  return xe(e, "overflowX");
}, ve = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Te(e, r);
    if (o) {
      var s = Ae(e, r), u = s[1], a = s[2];
      if (u > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Wt = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, jt = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Te = function(e, t) {
  return e === "v" ? _t(t) : Bt(t);
}, Ae = function(e, t) {
  return e === "v" ? Wt(t) : jt(t);
}, Ut = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, $t = function(e, t, n, r, o) {
  var s = Ut(e, window.getComputedStyle(t).direction), u = s * r, a = n.target, h = t.contains(a), l = !1, d = u > 0, v = 0, m = 0;
  do {
    if (!a)
      break;
    var E = Ae(e, a), w = E[0], i = E[1], f = E[2], p = i - f - s * w;
    (w || p) && Te(e, a) && (v += p, m += w);
    var y = a.parentNode;
    a = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !h && a !== document.body || // self content
    h && (t.contains(a) || t === a)
  );
  return (d && Math.abs(v) < 1 || !d && Math.abs(m) < 1) && (l = !0), l;
}, j = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, he = function(e) {
  return [e.deltaX, e.deltaY];
}, me = function(e) {
  return e && "current" in e ? e.current : e;
}, zt = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Ht = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Kt = 0, M = [];
function Vt(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(Kt++)[0], s = c.useState(Oe)[0], u = c.useRef(e);
  c.useEffect(function() {
    u.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var i = vt([e.lockRef.current], (e.shards || []).map(me), !0).filter(Boolean);
      return i.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), i.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = c.useCallback(function(i, f) {
    if ("touches" in i && i.touches.length === 2 || i.type === "wheel" && i.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = j(i), y = n.current, b = "deltaX" in i ? i.deltaX : y[0] - p[0], g = "deltaY" in i ? i.deltaY : y[1] - p[1], C, R = i.target, S = Math.abs(b) > Math.abs(g) ? "h" : "v";
    if ("touches" in i && S === "h" && R.type === "range")
      return !1;
    var x = ve(S, R);
    if (!x)
      return !0;
    if (x ? C = S : (C = S === "v" ? "h" : "v", x = ve(S, R)), !x)
      return !1;
    if (!r.current && "changedTouches" in i && (b || g) && (r.current = C), !C)
      return !0;
    var k = r.current || C;
    return $t(k, f, i, k === "h" ? b : g);
  }, []), h = c.useCallback(function(i) {
    var f = i;
    if (!(!M.length || M[M.length - 1] !== s)) {
      var p = "deltaY" in f ? he(f) : j(f), y = t.current.filter(function(C) {
        return C.name === f.type && (C.target === f.target || f.target === C.shadowParent) && zt(C.delta, p);
      })[0];
      if (y && y.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!y) {
        var b = (u.current.shards || []).map(me).filter(Boolean).filter(function(C) {
          return C.contains(f.target);
        }), g = b.length > 0 ? a(f, b[0]) : !u.current.noIsolation;
        g && f.cancelable && f.preventDefault();
      }
    }
  }, []), l = c.useCallback(function(i, f, p, y) {
    var b = { name: i, delta: f, target: p, should: y, shadowParent: Xt(p) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(g) {
        return g !== b;
      });
    }, 1);
  }, []), d = c.useCallback(function(i) {
    n.current = j(i), r.current = void 0;
  }, []), v = c.useCallback(function(i) {
    l(i.type, he(i), i.target, a(i, e.lockRef.current));
  }, []), m = c.useCallback(function(i) {
    l(i.type, j(i), i.target, a(i, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return M.push(s), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", h, L), document.addEventListener("touchmove", h, L), document.addEventListener("touchstart", d, L), function() {
      M = M.filter(function(i) {
        return i !== s;
      }), document.removeEventListener("wheel", h, L), document.removeEventListener("touchmove", h, L), document.removeEventListener("touchstart", d, L);
    };
  }, []);
  var E = e.removeScrollBar, w = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    w ? c.createElement(s, { styles: Ht(o) }) : null,
    E ? c.createElement(It, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Xt(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Yt = wt(Pe, Vt);
var qt = c.forwardRef(function(e, t) {
  return c.createElement(K, P({}, e, { ref: t, sideCar: Yt }));
});
qt.classNames = K.classNames;
export {
  en as C,
  He as D,
  Ge as F,
  z as P,
  qt as R,
  F as a,
  H as b,
  Ie as c,
  an as d,
  ln as e,
  sn as f,
  on as g,
  X as h,
  ct as i,
  fn as j,
  dn as k,
  cn as l,
  nn as m,
  Jt as n,
  rn as o,
  tn as q,
  Ee as r,
  un as u
};
